import TeamsTrialModal from "./TeamsTrialModal";
import {
  usePaymentMethods,
  usePricingPlans,
  useActivateTeamsTrial,
} from "@zapier/client";
import { useNotification } from "@zapier/utils";
import { useTranslations } from "@zapier/i18n";

interface Props {
  isTeamsTrialModalOpen: boolean;
  closeModal: () => void;
}

export const TeamsTrialModalWrapper = ({
  isTeamsTrialModalOpen,
  closeModal,
}: Props) => {
  const { createNotification } = useNotification();
  const t = useTranslations("teams-trial-modal");
  const { activateTeamsTrial } = useActivateTeamsTrial();
  const { hasPaymentSource } = usePaymentMethods();
  const { pricingPlans } = usePricingPlans();

  const teamPlan = pricingPlans
    ?.find((plan) => plan?.planType === "Team")
    ?.plans.find(
      (plan) => plan.name === "Team (50,000 Tasks)" && plan.interval === "year",
    );

  // yearly amount to monthly
  const teamsPlanPrice = (teamPlan?.amount || 0) / 100 / 12;

  const startTeamsTrial = async () => {
    activateTeamsTrial(
      { hasPaymentSource },
      {
        onSettled: () => {
          createNotification({
            message: t("notifications.trial-started-success"),
            type: "success",
          });
        },
        onError: () => {
          createNotification({
            message: t("notifications.trial-start-error"),
            type: "error",
          });
        },
      },
    );
  };

  return (
    <div>
      {isTeamsTrialModalOpen && (
        <TeamsTrialModal
          teamsPlanPrice={teamsPlanPrice}
          hasPaymentSource={!!hasPaymentSource}
          onClose={closeModal}
          onSubmit={startTeamsTrial}
        />
      )}
    </div>
  );
};
